import { SVGProps } from '@components/Icon/types';

export const CalendarSchedule = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}>
    <path
      d="M4.0625 1C4.30412 1 4.5 1.19588 4.5 1.4375V1.875H11.5V1.4375C11.5 1.19588 11.6959 1 11.9375 1C12.1791 1 12.375 1.19588 12.375 1.4375V1.875H13.25C14.2165 1.875 15 2.6585 15 3.625V13.25C15 14.2165 14.2165 15 13.25 15H2.75C1.7835 15 1 14.2165 1 13.25V3.625C1 2.6585 1.7835 1.875 2.75 1.875H3.625V1.4375C3.625 1.19588 3.82088 1 4.0625 1ZM2.75 2.75C2.26675 2.75 1.875 3.14175 1.875 3.625V4.5H14.125V3.625C14.125 3.14175 13.7332 2.75 13.25 2.75H2.75ZM14.125 5.375H1.875V13.25C1.875 13.7332 2.26675 14.125 2.75 14.125H13.25C13.7332 14.125 14.125 13.7332 14.125 13.25V5.375Z"
      fill={fill}
    />
    <path
      d="M10.625 7.5625C10.625 7.32088 10.8209 7.125 11.0625 7.125H11.9375C12.1791 7.125 12.375 7.32088 12.375 7.5625V8.4375C12.375 8.67912 12.1791 8.875 11.9375 8.875H11.0625C10.8209 8.875 10.625 8.67912 10.625 8.4375V7.5625Z"
      fill={fill}
    />
    <path
      d="M8 7.5625C8 7.32088 8.19588 7.125 8.4375 7.125H9.3125C9.55412 7.125 9.75 7.32088 9.75 7.5625V8.4375C9.75 8.67912 9.55412 8.875 9.3125 8.875H8.4375C8.19588 8.875 8 8.67912 8 8.4375V7.5625Z"
      fill={fill}
    />
    <path
      d="M6.25 10.1875C6.25 9.94588 6.44588 9.75 6.6875 9.75H7.5625C7.80412 9.75 8 9.94588 8 10.1875V11.0625C8 11.3041 7.80412 11.5 7.5625 11.5H6.6875C6.44588 11.5 6.25 11.3041 6.25 11.0625V10.1875Z"
      fill={fill}
    />
    <path
      d="M3.625 10.1875C3.625 9.94588 3.82088 9.75 4.0625 9.75H4.9375C5.17912 9.75 5.375 9.94588 5.375 10.1875V11.0625C5.375 11.3041 5.17912 11.5 4.9375 11.5H4.0625C3.82088 11.5 3.625 11.3041 3.625 11.0625V10.1875Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'calendar-schedule';
